export enum Permission {
  ACCOUNT_READ = 'account:read',
  ACCOUNT_MANAGE = 'account:manage',
  ANALYTICS_READ = 'analytics:read',
  APPLICATIONS_MANAGE = 'applications:manage',
  BALANCES_READ = 'balances:read',
  BANK_ACCOUNTS_READ = 'bankaccounts:read',
  BILLING_DESCRIPTORS_MANAGE = 'billingdescriptors:manage',
  CREDENTIAL_FORWARDING_READ = 'forward-credentials:read',
  DISPUTES_MANAGE = 'disputes:manage',
  DISPUTES_READ = 'disputes:read',
  INVOICES_READ = 'invoices:read',
  ISSUING_MANAGE = 'issuing:manage',
  ISSUING_MANAGE_AUTH_RELAY = 'issuing:manage-authrelay',
  ISSUING_READ = 'issuing:read',
  ISSUING_READ_SENSITIVE = 'issuing:read-sensitive',
  KEYS_CREATE = 'keys:create',
  KEYS_MANAGE = 'keys:manage',
  KEYS_READ = 'keys:read',
  MARKETPLACE_READ = 'marketplace:read',
  PAYMENT_LINKS_CREATE = 'paymentlinks:create',
  PAYMENT_LINKS_READ = 'paymentlinks:read',
  PAYMENTS_CAPTURE = 'payments:capture',
  PAYMENTS_MANAGE_DOCUMENT = 'payments:manage-document',
  PAYMENTS_READ = 'payments:read',
  PAYMENTS_REFUND = 'payments:refund',
  PAYMENTS_SEARCH = 'payments:search',
  PAYMENTS_VOID = 'payments:void',
  PAYOUTS_READ = 'payouts:read',
  PAYOUTS_SEARCH = 'payouts:search',
  REPORTS_GENERATE = 'reports:generate',
  RISK_MANAGE = 'risk:manage',
  RISK_READ = 'risk:read',
  ROLES_MANAGE = 'roles:manage',
  RULES_MANAGE = 'rules:manage',
  RULES_READ = 'rules:read',
  STAKEHOLDERS_READ = 'stakeholders:read',
  SECURITY_MANAGE = 'security:manage',
  SECURITY_READ = 'security:read',
  USER_ACTIVITY_READ = 'user-activity:read',
  USERS_MANAGE = 'users:manage',
  USERS_READ = 'users:read',
  VAULT_READ = 'vault:read',
  NETWORK_TOKENS_READ = 'network-tokens:read',
  WORKFLOWS_MANAGE = 'workflows:manage',
  WORKFLOWS_READ = 'workflows:read',
  WORKFLOWS_READ_KEYS = 'workflows:read-keys',
  BUSINESS_ACCOUNT_MANAGE_MY_CARDS = 'business-account:manage-my-cards',
  BUSINESS_ACCOUNT_VIEW_ALL_CARDS = 'business-account:view-all-cards',
  BUSINESS_ACCOUNT_VIEW_ALL_CREDENTIALS = 'business-account:view-all-credentials',
  BUSINESS_ACCOUNT_EDIT_ALL_CARDS = 'business-account:edit-all-cards',
  BUSINESS_ACCOUNT_CREATE_CARDS = 'business-account:create-cards',
  TRANSFERS_MANAGE = 'transfers:manage',
}
